"use client";

import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const PAGE_ID_PREFIX = "meta";

export default function MetaPage() {
  return (
    <div
      id={`${PAGE_ID_PREFIX}-page`}
      className="flex min-h-screen flex-col bg-slate-950 text-slate-50"
    >
      <Header idPrefix={`${PAGE_ID_PREFIX}-header`} />

      <main
        id={`${PAGE_ID_PREFIX}-main`}
        className="flex flex-1 flex-col items-center justify-center px-4"
      >
        <div className="max-w-md text-center space-y-4">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-slate-700 bg-slate-900 text-2xl">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </div>
          <h1
            id={`${PAGE_ID_PREFIX}-title`}
            className="text-2xl font-bold text-slate-100"
          >
            Meta Analysis
          </h1>
          <p className="text-sm text-slate-400">
            This feature is under construction. Check back soon for tournament meta breakdowns and popular deck lists.
          </p>
          <div
            id={`${PAGE_ID_PREFIX}-donate-callout`}
            className="rounded-lg border border-slate-700/80 bg-slate-900/60 px-4 py-3 text-left text-sm text-slate-400"
          >
            <p className="leading-relaxed">
              Building meta the way we want it means a real backend: ingesting results, keeping lists fresh, and
              serving them reliably. That takes time and hosting. If Punk Records helps you, consider{" "}
              <a
                href="https://ko-fi.com/hugoprudente"
                target="_blank"
                rel="noreferrer"
                className="font-medium text-blue-400 hover:underline"
              >
                supporting the project
              </a>
              —it directly makes those features more likely to ship.
            </p>
          </div>
        </div>
      </main>

      <Footer idPrefix={`${PAGE_ID_PREFIX}-footer`} />
    </div>
  );
}
